import {
  BaseTransaction,
  IntegrationLog,
  Response,
  apiAbortController,
} from '@ui/src';
import {
  CheckTransaction,
  CheckTransactionResult,
} from '../../../types/check-transaction';
import api from '../../../api/api';
import {
  CreateNostroTransaction,
  NostroTransactionValidator,
  UpdateNostroTransaction,
} from '../types';
import { StatusUpdate } from '../../transactions/type';

export const nostroTransactionsListApi = api.injectEndpoints({
  endpoints: (build) => ({
    getNostroList: build.query<Response<BaseTransaction>, string>({
      query: (query) => ({
        url: `/v1/transactions-nostro${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getNostroListStatuses: build.query<Response<StatusUpdate>, string>({
      query: (query) => ({
        url: `/v1/transactions-nostro/statuses${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getNostroTransactionById: build.query<{ data: BaseTransaction }, string>({
      query: (id) => ({
        url: `/v1/transactions-nostro/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createNostroTransaction: build.mutation<
      { data: BaseTransaction },
      CreateNostroTransaction
    >({
      query: (body) => ({
        url: '/v1/transactions-nostro',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateNostroTransaction: build.mutation<
      { data: BaseTransaction },
      { body: UpdateNostroTransaction; id: string }
    >({
      query: (data) => ({
        url: `/v1/transactions-nostro/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getNostroTransactionValidators: build.query<
      { data: NostroTransactionValidator },
      void
    >({
      query: () => ({
        url: '/v1/transactions-nostro/validators',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    checkNostroTransaction: build.mutation<
      { data: CheckTransactionResult },
      {
        body: CheckTransaction;
        abortController: {
          abortPendingRequest: () => void;
          getSignalToken: () => AbortSignal;
        };
      }
    >({
      query: ({ body, abortController }) => ({
        url: `/v1/transactions-nostro/check`,
        method: 'POST',
        body,
        signal: abortController.getSignalToken(),
      }),
    }),
    exportNostroTransaction: build.mutation<
      any,
      Record<string, string[] | string | number>
    >({
      query: (body) => ({
        url: '/v1/transactions-nostro/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getNostroIntegrationLogs: build.query<
      Response<IntegrationLog>,
      { query: string; id: string }
    >({
      query: ({ query, id }) => ({
        url: `/v1/psp-integrations-logs${query}&transactionIds=${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useGetNostroListQuery,
  useLazyGetNostroListQuery,
  useLazyGetNostroTransactionByIdQuery,
  useCreateNostroTransactionMutation,
  useUpdateNostroTransactionMutation,
  useGetNostroTransactionValidatorsQuery,
  useCheckNostroTransactionMutation,
  useLazyGetNostroListStatusesQuery,
  useExportNostroTransactionMutation,
  useLazyGetNostroIntegrationLogsQuery,
} = nostroTransactionsListApi;

export const {
  endpoints: {
    getNostroList,
    getNostroTransactionById,
    getNostroTransactionValidators,
    checkNostroTransaction,
    updateNostroTransaction,
    getNostroListStatuses,
    exportNostroTransaction,
    getNostroIntegrationLogs,
  },
} = nostroTransactionsListApi;
